import { render, staticRenderFns } from "./waterAnalyze.vue?vue&type=template&id=0fd23d4c&scoped=true&"
import script from "./waterAnalyze.vue?vue&type=script&lang=js&"
export * from "./waterAnalyze.vue?vue&type=script&lang=js&"
import style0 from "./waterAnalyze.vue?vue&type=style&index=0&id=0fd23d4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd23d4c",
  null
  
)

export default component.exports